export default "__VITE_ASSET__K_x2jIES__"